<elder-table class="flex" matSort [data]="data()" [idField]="'id'" (itemClick)="batchClick($event)">
  <!-- icon Column -->
  <ng-container matColumnDef="icon">
    <th mat-header-cell *matHeaderCellDef style="width: 30px"></th>
    <td mat-cell *matCellDef="let terminalBatch">
      @if (canStartBatch(terminalBatch.workBatch)) {
        <mat-icon>widgets</mat-icon>
      } @else {
        <div>
          <mat-icon [color]="'warn'">play_disabled</mat-icon>
        </div>
      }
    </td>
  </ng-container>

  <!-- number Column -->
  <ng-container matColumnDef="priority">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'context.number' | translate }}
    </th>
    <td mat-cell *matCellDef="let terminalBatch">
      <span class="mat-subtitle-2">{{ terminalBatch.workBatch.number }}</span>
    </td>
  </ng-container>

  <!-- state Column -->
  <ng-container matColumnDef="state">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'context.state' | translate }}
    </th>
    <td mat-cell *matCellDef="let terminalBatch">
      {{ 'WorkBatchState.' + terminalBatch.workBatch.state | translate }}
    </td>
  </ng-container>

  <!-- inter-site Column -->
  <ng-container matColumnDef="inter-site">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'facilities.facilities' | translate }}
    </th>
    <td mat-cell *matCellDef="let terminalBatch">
      <div class="flex layout-row gap-lg place-start-center">
        @if (
          terminalBatch.workOrder.manufactureFacility !== terminalBatch.workOrder.collectingFacility
        ) {
          <div class="layout-row place-start-center gap-lg">
            <span>{{ terminalBatch.workOrder.manufactureFacility }}</span>
            <mat-icon color="warn">east</mat-icon>
          </div>
        }
        <span>{{ terminalBatch.workOrder.collectingFacility }}</span>
      </div>
    </td>
  </ng-container>

  <!-- numberOfItems Column -->
  <ng-container matColumnDef="numberOfItems">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'context.items' | translate }}
    </th>
    <td mat-cell *matCellDef="let terminalBatch">
      {{ terminalBatch.workBatch.numberOfItems }}
    </td>
  </ng-container>

  <!-- piecesCount Column -->
  <ng-container matColumnDef="piecesCount">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'context.pieces' | translate }}
    </th>
    <td mat-cell *matCellDef="let terminalBatch">
      {{ terminalBatch.workBatch.quantities['stk']?.value }}
    </td>
  </ng-container>

  <!-- weight Column -->
  <ng-container matColumnDef="weight">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'context.weight' | translate }}
    </th>
    <td mat-cell *matCellDef="let terminalBatch">
      {{ terminalBatch.workBatch.weight | elderQuantity }}
    </td>
  </ng-container>

  <!-- workBatchLine Column -->
  <ng-container matColumnDef="workBatchLine">
    <th mat-header-cell *matHeaderCellDef class="cell-10 align-right">
      {{ 'context.status' | translate }}
    </th>
    <td mat-cell *matCellDef="let terminalBatch" class="align-right">
      <app-work-batch-line class="flex" [batch]="terminalBatch.workBatch"></app-work-batch-line>
    </td>
  </ng-container>
</elder-table>
